import { CalculatorPrototypeDrive, FormTypes } from "../types/FormTypes";

export const formOrder = [
  "orientation",
  "travelDistance",
  "driveSystemBelt",
  "driveSystemChain",
  "driveSystemLeadScrew",
  "driveSystemBallScrew",
  "payloadMass",
  "payloadXOffset",
  "payloadYOffset",
  "payloadZOffset",
  "externalForceMomentX1",
  "externalForceMomentY1",
  "externalForceMomentZ1",
  "cycleStroke",
  "maxVelocity",
  "maxAcceleration",
  "strokeTime",
  "timeAtMaxV",
  "strokeAtMaxV",
  "motionProfileWaitTime1",
  "motionProfileWaitTime2",
  "motionProfileShape",
  "cyclesPerDay",
  "cyclesHoursPerDay",
  "cyclesDaysPerMonth",
  "temperatureRangeTemp1",
  "temperatureRangeTemp2",
  "adjustmentFactor",
];

export const mapFormData = (data: FormTypes) => {
  const dto: CalculatorPrototypeDrive = {
    date: new Date(),
    orientation: data.orientation,
    travelDistance: data.travelDistance,
    driveSystemBelt: data.driveSystemBelt,
    driveSystemChain: data.driveSystemChain,
    driveSystemLeadScrew: data.driveSystemLeadScrew,
    driveSystemBallScrew: data.driveSystemBallScrew,
    driveSystemSelected: "",
    payloadMass: data.payloadMass ? data.payloadMass : 0,
    massOffsetX: data.payloadXOffset ? data.payloadXOffset : 0,
    massOffsetY: data.payloadYOffset ? data.payloadYOffset : 0,
    massOffsetZ: data.payloadZOffset ? data.payloadZOffset : 0,
    forceDirection1: data.externalForceForceDirection1,
    appliedForce1: data.externalForceAppliedForce1,
    forceOffsetX1: data.externalForceAppliedForceX1,
    forceOffsetY1: data.externalForceAppliedForceY1,
    forceOffsetZ1: data.externalForceAppliedForceZ1,
    forceDirection2: data.externalForceForceDirection2,
    appliedForce2: data.externalForceAppliedForce2,
    forceOffsetX2: data.externalForceAppliedForceX2,
    forceOffsetY2: data.externalForceAppliedForceY2,
    forceOffsetZ2: data.externalForceAppliedForceZ2,
    forceDirection3: data.externalForceForceDirection3,
    appliedForce3: data.externalForceAppliedForce3,
    forceOffsetX3: data.externalForceAppliedForceX3,
    forceOffsetY3: data.externalForceAppliedForceY3,
    forceOffsetZ3: data.externalForceAppliedForceZ3,
    momentX1: data.externalForceMomentX1,
    momentY1: data.externalForceMomentY1,
    momentZ1: data.externalForceMomentZ1,
    adjustmentFactor: data.adjustmentFactor,
    mpiProfileType: data.motionProfileShape,
    mpiMaxAcceleration: data.maxAcceleration,
    mpiMaxVelocity: data.maxVelocity,
    mpiStroke: data.cycleStroke ? data.cycleStroke : 0,
    mpiStrokeTime: data.strokeTime ? data.strokeTime : 0,
    mpiTimeAtMaxV: data.timeAtMaxV ? data.timeAtMaxV : 0,
    mpiStrokeAtMaxV: data.strokeAtMaxV ? data.strokeAtMaxV : 0,
    mpiReturnProfileType: "",
    mpiWaitTime1: data.motionProfileWaitTime1 ? data.motionProfileWaitTime1 : 0,
    mpiWaitTime2: data.motionProfileWaitTime2 ? data.motionProfileWaitTime2 : 0,
    mpiReturnTime: 0,
    mpiTotalCycleTime: 0,
    dciCyclesPerMonth: 0,
    dciDaysPerMonth: data.cyclesDaysPerMonth,
    dciCyclesPerDay: data.cyclesPerDay,
    dciHoursPerDay: data.cyclesHoursPerDay,
    dciCyclesPerHour: 0,
    minBearingLifeKM: 0,
    minBearingLifeMonths: 0,
    minBearingFOS: 0,
    minDriveFOS: 0,
    maxVelocity: 0,
    systemForcesDriveAccel: 0,
    outputValidation: 0,
    summary: "",
    projectName: data.projectName,
    temperatureRangeTemp1: data.temperatureRangeTemp1,
    temperatureRangeTemp2: data.temperatureRangeTemp2,
  };
  return dto;
};

export const reverseMapFormData = (dto: any): any => {
  return {
    // Basic fields
    orientation: dto.orientation,
    travelDistance: dto.travelDistance,
    
    // Drive system booleans
    driveSystemBelt: dto.driveSystemBelt,
    driveSystemChain: dto.driveSystemChain,
    driveSystemLeadScrew: dto.driveSystemLeadScrew,
    driveSystemBallScrew: dto.driveSystemBallScrew,
    
    // Payload values
    payloadMass: dto.payloadMass,
    payloadXOffset: dto.massOffsetX,
    payloadYOffset: dto.massOffsetY,
    payloadZOffset: dto.massOffsetZ,
    
    // External Force 1
    externalForceForceDirection1: dto.forceDirection1,
    externalForceAppliedForce1: dto.appliedForce1,
    externalForceAppliedForceX1: dto.forceOffsetX1,
    externalForceAppliedForceY1: dto.forceOffsetY1,
    externalForceAppliedForceZ1: dto.forceOffsetZ1,
    
    // External Force 2
    externalForceForceDirection2: dto.forceDirection2 ?? "",
    externalForceAppliedForce2: dto.appliedForce2 ?? 0,
    externalForceAppliedForceX2: dto.forceOffsetX2 ?? 0,
    externalForceAppliedForceY2: dto.forceOffsetY2 ?? 0 ,
    externalForceAppliedForceZ2: dto.forceOffsetZ2 ?? 0,
    
    // External Force 3
    externalForceForceDirection3: dto.forceDirection3 ?? "",
    externalForceAppliedForce3: dto.appliedForce3 ?? 0,
    externalForceAppliedForceX3: dto.forceOffsetX3 ?? 0,
    externalForceAppliedForceY3: dto.forceOffsetY3 ?? 0,
    externalForceAppliedForceZ3: dto.forceOffsetZ3 ?? 0,

    // Monent 1
    externalForceMomentX1: dto.momentX1,
    externalForceMomentY1: dto.momentY1,
    externalForceMomentZ1: dto.momentZ1,
    
    // Adjustment factor
    adjustmentFactor: dto.adjustmentFactor,
    
    // Motion profile fields
    motionProfileShape: dto.mpiProfileType,
    maxAcceleration: dto.mpiMaxAcceleration,
    maxVelocity: dto.mpiMaxVelocity,
    cycleStroke: dto.mpiStroke,
    strokeTime: dto.mpiStrokeTime,
    timeAtMaxV: dto.mpiTimeAtMaxV,
    strokeAtMaxV: dto.mpiStrokeAtMaxV,
    motionProfileWaitTime1: dto.mpiWaitTime1,
    motionProfileWaitTime2: dto.mpiWaitTime2,
    
    // Cycle information
    cyclesDaysPerMonth: dto.dciDaysPerMonth,
    cyclesPerDay: dto.dciCyclesPerDay,
    cyclesHoursPerDay: dto.dciHoursPerDay,

    // Additional Info
    projectName: dto.projectName,
    externalForceCount: dto.externalForceCount,
    momentsCount: dto.momentsCount,
    currentPage: dto.currentPage,
    selectedProductIds: dto.selectedProductIds,
    temperatureRangeTemp1: dto.temperatureRangeTemp1,
    temperatureRangeTemp2: dto.temperatureRangeTemp2,
  };
};
